'use strict'
import $ from 'jquery'


$('.data-discriminatory-list').each(function (list, data) {
    let inputsSelector = $(elem).data('for');
    

})
